<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-12",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 32,
      navigateType: 'CLICK_NEXT',
      content: {
        componentsType: {
          pc: 'cardBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/21-Hair.png'),
        mainTitle: 'Your hair issues or concerns are:',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'Dull',
              clickedIcon: require('@/assets/icon/clickedIcon/36-Dull.png'),
              icon: require('@/assets/icon/questionIcon/36-Dull.png')
            },{
              text: 'End split easily',
              clickedIcon: require('@/assets/icon/clickedIcon/36-End split easily.png'),
              icon: require('@/assets/icon/questionIcon/31-End split easily.png')
            },{
              text: 'Hairline moves up',
              clickedIcon: require('@/assets/icon/clickedIcon/36-Hairline moves up.png'),
              icon: require('@/assets/icon/questionIcon/31-Hairline moves up.png')
            }
          ],[
            {
              text: 'Frequent hair loss',
              clickedIcon: require('@/assets/icon/clickedIcon/36-Frequent hair loss.png'),
              icon: require('@/assets/icon/questionIcon/31-Frequent hair loss.png')
            },{
              text: 'None of these',
              clickedIcon: require('@/assets/icon/clickedIcon/36-None of these.png'),
              icon: require('@/assets/icon/questionIcon/31-None of these.png'),
              unique: true
            }
          ]
        ],
      }
    }
  },
  computed: {
    nextPage: function(){
      if(this.$store.state.qsData[21] && this.$store.state.qsData[21].answer.length>0){
        if(this.$store.state.qsData[21].answer.indexOf('Emotion') !== -1){
          return '/questionnaire/section2/13'
        }else if(this.$store.state.qsData[21].answer.indexOf('Menstrual problems') !== -1){
          return '/questionnaire/section2/16'
        }else if(this.$store.state.qsData[21].answer.indexOf('Women\'s Health') !== -1){
          return '/questionnaire/section2/18'
        }else{
          return '/questionnaire/section3'
        }
      }else{
        return '/questionnaire/section3'
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
